import React from "react";
import styled from "styled-components";
import { px2rem } from "../../../ezUI/StyledComponents/utils";
import { AssetImageUrl } from "../../../assets/imgUrl";
import Constant, { Host } from "../../../utils/constant";
const Layout = styled.section `
	height: ${px2rem(55)};
	border-top: 1px solid #eee;
	border-bottom: 1px solid #e2e2e2;
	background: #fff;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 ${px2rem(12)} 0 ${px2rem(2.4)};
`;
const HeaderSide = styled.section `
	width: ${px2rem(63)};
	height: ${px2rem(55)};
	display: flex;
	align-items: center;
	justify-content: space-between;
`;
const HeaderIcon = styled.div `
	width: ${px2rem(30)};
	height: ${px2rem(55)};
	display: flex;
	align-items: center;
	justify-content: center;
	> img {
		width: ${px2rem(24)};
		height: ${px2rem(24)};
	}
`;
const CartIcon = styled(HeaderIcon) `
	position: relative;
`;
const Badge = styled.div `
	position: absolute;
	top: 0.375rem;
	right: -0.375rem;
	display: block;
	z-index: 10;
	background: #e33124;
	color: #fff;
	min-width: ${px2rem(16)};
	height: ${px2rem(16)};
	text-align: center;
	line-height: ${px2rem(16)};
	padding: 0;
	font-size: ${px2rem(12)};
	font-weight: 400;
	border-radius: ${px2rem(8)};
	span {
		padding: 0 4px;
	}
`;
const Title = styled.a `
	width: ${px2rem(160)};
	height: 100%;
	position: relative;
	> img {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
`;
export function HeaderLayout(props) {
    const { language_code = Constant.language || "en", total_results = 0, onSearchIconClick = () => { }, onMenuIconClick = () => { } } = props;
    const BaseUrl = Host[String(Constant.isUat)];
    function goPage(path) {
        window.location.href = path;
    }
    return (React.createElement(Layout, null,
        React.createElement(HeaderSide, null,
            React.createElement(HeaderIcon, { onClick: () => history.back() },
                React.createElement("img", { src: AssetImageUrl["ic_back@3x.png"], alt: "back" })),
            React.createElement(HeaderIcon, { onClick: onMenuIconClick },
                React.createElement("img", { src: AssetImageUrl["ic_menu@3x.png"], alt: "menu" }))),
        React.createElement(Title, { href: "/" },
            React.createElement("img", { src: "https://li0.rightinthebox.com/images/dfp/fs-images/2020/017ad93f7ef3d1d7d82aab1380a03c00.jpg", style: { width: px2rem(160), height: px2rem(30) }, alt: "Lightinthebox" })),
        React.createElement(HeaderSide, null,
            React.createElement(HeaderIcon, { onClick: onSearchIconClick },
                React.createElement("img", { src: AssetImageUrl["ic_search@3x.png"], alt: "search", style: { width: px2rem(24), height: px2rem(24) } })),
            React.createElement(CartIcon, { onClick: () => goPage(`${BaseUrl.gmHost}/${language_code}/cart`) },
                React.createElement("img", { src: AssetImageUrl["tabbar_ic_cart@3x.png"], alt: "cart", style: { width: px2rem(24), height: px2rem(24) } }),
                !!total_results ? (React.createElement(Badge, null,
                    React.createElement("span", null, total_results > 999 ? "999+" : total_results))) : null))));
}
